import { render, staticRenderFns } from "./scope87.vue?vue&type=template&id=635d9610&scoped=true"
import script from "./scope87.vue?vue&type=script&lang=js"
export * from "./scope87.vue?vue&type=script&lang=js"
import style0 from "./scope87.vue?vue&type=style&index=0&id=635d9610&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d9610",
  null
  
)

export default component.exports